export default [
    {
        title: "Discover Kyoto",
        img: "https://i.imgur.com/0FKHI5d.png",
        description:
            "Implemented React to build a mockup website and designed a responsive UI to showcase the city of Kyoto, Japan. Worked with React Hooks and third-party libraries.",
        technologies: "React | JavaScript | CSS | HTML",
        url: "https://kyotodiscover.com",
        gitUrl: "https://github.com/samu001/Discover-Kyoto",
    },
    {
        title: "Wine Buddy",
        img: "https://i.imgur.com/cHUkgbt.png",
        description:
            "With the use of an API, implemented a program to pair different foods with wines types. The application also provides brand recomendations and shopping links.",
        technologies: "Use of API's | JavaScript",
        url: "https://winebuddy.netlify.app",
        gitUrl: "https://github.com/samu001/wine-buddy",
    },
    {
        title: 'Mobile App Game "Fit or Blast"',
        img: "https://i.imgur.com/L4wqQks.png",
        description:
            "Developed a casual mobile game using C# and the Unity Engine. Worked with Photoshop to create the assets of the game",
        technologies: "Unity Engine | C# | Photoshop",
        url: "https://play.google.com/store/apps/details?id=com.PolarPanda.FitorBlast",
        gitUrl: "https://github.com/samu001/fit-or-blast",
    },
    {
        title: "Password Generator",
        img: "https://i.imgur.com/x0SNrnq.png",
        description:
            "Used JavaScript to create the logic for a random password generator. Includes a character amount slider, and filter options for symbols and numbers.",
        technologies: "JavaScript | HTML | CSS ",
        url: "https://passpawner.netlify.app",
        gitUrl: "https://github.com/samu001/Password-Generator",
    },
];
